import Vue from 'vue'
import { config, library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBars } from '@fortawesome/pro-regular-svg-icons'
import { faTimes, faPlayCircle } from '@fortawesome/pro-light-svg-icons'
import { faPlay } from '@fortawesome/pro-solid-svg-icons'

config.autoAddCss = true

library.add(faBars)
library.add(faTimes)
library.add(faPlay)
library.add(faPlayCircle)

Vue.component('FontAwesomeIcon', FontAwesomeIcon)
